import React, { useEffect } from "react";
import RegistrationForm from "./RegistrationForm";
import { useNavigate } from "react-router-dom";

const Registration = () => {
  const navigate = useNavigate();
  const Token = localStorage.getItem("token");
  const userType = localStorage.getItem("user-type");

  useEffect(() => {
    if (Token) {
      if (userType == "member") {
        navigate("/member-info");
      } else {
        navigate("/dashboard");
      }
    }
  }, [Token]);
  return (
    <div>
      <RegistrationForm />
    </div>
  );
};

export default Registration;
